import { call, put, takeEvery, takeLatest } from "redux-saga/effects"; // Added takeLatest
import AXIOS_INSTANCE from "../../utils/Config";

import {
  sitesLoading,
  submitSitesActionDispatcher,
  submitSitesErrorDispatcher,
  SUBMIT_SITES_ACTION_REQUESTED,
} from "./Action"; // Path should come here

const postSitesAPI = async (postData) => {
  const result = await AXIOS_INSTANCE.post(
    "/CustomerPortal/Post?sitelist=ccv&sitenumber=5",
    {
      ...postData,
    }
  );
  return result;
};

// Define the API function for fetching sites by filters
const getSitesAPI = async (params) => {
  const result = await AXIOS_INSTANCE.post(
    "/CustomerPortal/Post?sitelist=ccv&sitenumber=5", // Use the same endpoint
    {
      ...params,
    }
  );
  return result;
};

function* submitSitesSaga({ postData, filterQuery }) {
  try {
    yield put(sitesLoading(true));
    const data = yield call(postSitesAPI, postData);
    yield put(submitSitesActionDispatcher(data.data, filterQuery));
    yield put(submitSitesErrorDispatcher({}));
    yield put(sitesLoading(false));
  } catch (e) {
    yield put(submitSitesActionDispatcher({}));
    yield put(
      submitSitesErrorDispatcher(e.response.data, console.log(e.response))
    );
    yield put(sitesLoading(false));
  }
}

function* fetchSitesByFiltersSaga(action) {
  try {
    yield put(sitesLoading(true));
    // Use the defined API function
    const data = yield call(getSitesAPI, action.payload);
    
    // Update sites in Redux store using the same action dispatcher
    yield put(submitSitesActionDispatcher(data.data, ""));
    yield put(submitSitesErrorDispatcher({}));
    yield put(sitesLoading(false));
  } catch (error) {
    console.error('Error fetching sites by filters:', error);
    yield put(submitSitesActionDispatcher({}));
    yield put(submitSitesErrorDispatcher(error.response?.data || {}));
    yield put(sitesLoading(false));
  }
}

function* submitSitesWatcher() {
  yield takeEvery(SUBMIT_SITES_ACTION_REQUESTED, submitSitesSaga);
  // Add this to your saga watcher
  yield takeLatest('FETCH_SITES_BY_FILTERS', fetchSitesByFiltersSaga);
}

export default submitSitesWatcher;